import * as Mobile from '../functions/Mobile.js';
const { ofetch } = require("ofetch");

const $Navigation1A = $('.component-navigation-1A');
const $Navigation1APanelTrigger = $('[data-navigation-1a-panel-trigger]');

var Navigation1AIsMobile = false;
var Navigation1APanelsFadeIn = false;

const Navigation1A = document.getElementsByClassName('component-navigation-1A--state')[0];
const Navigation1ATop = document.getElementsByClassName('component-navigation-1A__top')[0];
const Navigation1ABottom = document.getElementsByClassName('component-navigation-1A__bottom')[0];

if (Navigation1A && Navigation1ATop && Navigation1ABottom) {
    let Navigation1AIsPastTop = false;
    let Navigation1AIsPastBottom = false;
    let Navigation1ABottomObserver;

    //1. Observer for Point A (Start Sticky)
    const topObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            Navigation1AIsPastTop = !entry.isIntersecting && entry.boundingClientRect.y < 0;
            Navigation1AUpdateNavState();
        });
    });
    topObserver.observe(Navigation1ATop);
    
    // 2. Function to build the bottom observer
    function Navigation1ACreateBottomObserver() {
        // Clear out the old observer if it exists
        if (Navigation1ABottomObserver) {
            Navigation1ABottomObserver.disconnect();
        }

        const Navigation1AHeight = Navigation1A.offsetHeight;

        Navigation1ABottomObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                Navigation1AIsPastBottom = !entry.isIntersecting && entry.boundingClientRect.y <= (Navigation1AHeight + 2);
                Navigation1AUpdateNavState();
            });
        }, {
            // Set the new margin based on the fresh height
            rootMargin: `-${Navigation1AHeight}px 0px 0px 0px` 
        });
        
        Navigation1ABottomObserver.observe(Navigation1ABottom);
    }

    // Initialize the bottom observer on page load
    Navigation1ACreateBottomObserver();

    // 3. ResizeObserver to catch display: none -> display: block changes
    const resizeObserver = new ResizeObserver(() => {
        // Force a manual check of the top trigger. This catches the layout shift 
        // if the trigger was already scrolled past while the nav was hidden.
        Navigation1AIsPastTop = Navigation1ATop.getBoundingClientRect().y < 0;
        
        Navigation1ACreateBottomObserver();
        Navigation1AUpdateNavState();
    });
    resizeObserver.observe(Navigation1A);

    // 4. Central Logic for the Nav State
    function Navigation1AUpdateNavState() {
        // Safeguard: If the nav is hidden on mobile, strip sticky classes and stop
        if (Navigation1A.offsetHeight === 0) {
            Navigation1A.classList.remove('is-sticky', 'is-hidden');
            return;
        }

        if (!Navigation1AIsPastTop) {
            // Zone 1: Above Point A (Normal flow)
            Navigation1A && Navigation1A.classList.remove('is-sticky', 'is-hidden');
            
        } else if (Navigation1AIsPastTop && !Navigation1AIsPastBottom) {
            // Zone 2: Between Point A and Point B (Strictly Sticky)
            Navigation1A && Navigation1A.classList.add('is-sticky');
            Navigation1A && Navigation1A.classList.remove('is-hidden');
            
        } else if (Navigation1AIsPastBottom) {
            // Zone 3: Below Point B (Inactive/Hidden)
            Navigation1A && Navigation1A.classList.remove('is-sticky');
            Navigation1A && Navigation1A.classList.add('is-hidden');
        }
    }
}

$(function() {
    const fetchData = function() {
        var $Navigation1APanel = $('.component-navigation-1A__panel', '.component-navigation-1A');
        $Navigation1APanel.each(async function(index, element) {
            var $element = $(element);
            var $data_container = $element.find('.panel-data-container');
            var action = $element.data('navigation-1a-panel-fetch');
            if (!action) { return true; }

            const response = await ofetch(action, {
                method: "GET",
            });
            $data_container.html(response);
        })
    }

    fetchData();
});

$Navigation1A.on('mouseleave', function() {
    var $this = $(this);
    var $Navigation1ABlocks = $('.component-navigation-1A__blocks', $this);
    var $Navigation1APanel = $('.component-navigation-1A__panel', $this);
    Navigation1APanelsFadeIn = false;

    $('.component-navigation-1A__block-item--panel-trigger, .panel-reset', $this).removeClass('inactive');
    $Navigation1ABlocks.removeClass('active');
    $Navigation1APanel.removeClass('active');
    $this.removeClass('active');
});
$('.panel-reset').on('mouseenter', function() {
    var $this = $Navigation1A;
    var $Navigation1ABlocks = $('.component-navigation-1A__blocks', $this);
    var $Navigation1APanel = $('.component-navigation-1A__panel', $this);
    Navigation1APanelsFadeIn = false;

    $('.component-navigation-1A__block-item--panel-trigger, .panel-reset', $this).removeClass('inactive');
    $Navigation1ABlocks.removeClass('active');
    $Navigation1APanel.removeClass('active');
    $this.removeClass('active');
});
$Navigation1APanelTrigger.on('mouseenter', function() {
    if (Navigation1AIsMobile) { return; }
    var $this = $(this);
    var $Navigation1A = $(this).parents('.component-navigation-1A');
    var panel_label = $this.data('navigation-1a-panel-trigger');
    var $panel = $('[data-navigation-1A-panel-label="'+panel_label+'"]', $Navigation1A);

    //reset
    $('.component-navigation-1A__block-item--panel-trigger, .panel-reset', $Navigation1A).addClass('inactive'); 
    $('.component-navigation-1A__panel', $Navigation1A).removeClass('active fadeIn');
    
    //set
    $this.addClass('active').removeClass('inactive');
    $('.component-navigation-1A__blocks', $Navigation1A).addClass('active');
    $panel.addClass('active');
    $Navigation1A.addClass('active');

    //fade in any panel just once until all panels are closed
    if (!Navigation1APanelsFadeIn) {
        $panel.addClass('fadeIn');
        Navigation1APanelsFadeIn = true;
    }
});

$(window).on('resize load', function() {
    Navigation1AIsMobile = Mobile.IsMobile();
});